import cx from 'classnames';
import { Component, h } from 'preact';
import { PreactHTMLConverter } from 'preact-html-converter';

// components
import EmptyTable from './EmptyTable';

// internal
import { get_directory_slug } from '../election-utils';

const converter = PreactHTMLConverter();

type Props = {
  contest: { [key: string]: any };
  columnCount: number;
  contestTitle: string;
  includeCountyRundown?: boolean;
  isShowcaseRace?: boolean;
  renderParty: any;
  renderCandidate: any;
  embedType: string;
  broadcastHeaderImage: string;
  activeContestId: string;
  showContestTitleInShowcase?: boolean;
  hideEmptyParty?: boolean;
};

class Contest extends Component<Props> {
  render() {
    const {
      contest,
      columnCount,
      contestTitle,
      isShowcaseRace,
      showContestTitleInShowcase,
      renderParty,
      hideEmptyParty,
      embedType,
    } = this.props;

    const onePrimary = contest.length == 1;

    let onePrimaryParty;

    if (onePrimary) {
      onePrimaryParty = contest[0].party;
    }

    // Center if only one contest and not Senate or AG (never center in embed)
    const shouldCenter =
      embedType !== 'internal' &&
      onePrimary &&
      contest[0] &&
      contest[0].office !== 'U.S. Senate' &&
      contest[0].office !== 'Attorney General';

    const rowClass = cx({
      seat__races: !isShowcaseRace,
      seat__highlight_races: isShowcaseRace,
      'seat__races--centered': shouldCenter && !isShowcaseRace,
    });

    let directory_slug;

    if (contest[0]) {
      directory_slug = get_directory_slug(contest[0].office);
    }

    return (
      <div class="seat">
        {!isShowcaseRace && (
          <h3 class="seat__title">
            <span>{contestTitle}</span>
            {directory_slug[0] != null && (
              <a
                class="t-links-unset"
                href={`https://directory.texastribune.org/districts/${directory_slug[0]['directory-slug']}/${contest[0]['office_division']}/`}
              >
                <span
                  class="icon-div"
                  title="Click to learn more about this district"
                >
                  <svg class="icon icon-info">
                    <use xlinkHref="#icon-info"></use>
                  </svg>
                </span>
              </a>
            )}
          </h3>
        )}
        <div class={rowClass}>
          {onePrimary &&
            onePrimaryParty == 'Republican' &&
            !isShowcaseRace &&
            !hideEmptyParty && <EmptyTable party={'Democrat'} />}

          {!isShowcaseRace &&
            contest.map((party: any, index) => renderParty(party, index))}

          {isShowcaseRace && (
            <div>
              {renderParty(contest)}
            </div>
          )}
          {onePrimary &&
            onePrimaryParty == 'Democrat' &&
            !isShowcaseRace &&
            !hideEmptyParty && <EmptyTable party={'Republican'} />}
        </div>
      </div>
    );
  }
}

Contest.defaultProps = {
  isShowcaseRace: false,
  includeCountyRundown: false,
  hideEmptyParty: true,
};

export default Contest;
